import { render, staticRenderFns } from "./APIreadme.vue?vue&type=template&id=4fc8884a&"
import script from "./APIreadme.vue?vue&type=script&lang=js&"
export * from "./APIreadme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports